export interface Configuration {
  Environment: 'test' | 'dev' | 'prod' | string;
  ApplicationVersion: string;
}

export const configuration: Configuration = (window as any).EASX_CONFIGURATION || { Environment: 'test', ApplicationVersion: '0.0.0.0'};